/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Models_Eu_Only_HintInputs */



/**
* | output |
* | --- |
* | "Show only models served from EU infrastructure." |
*
* @param {Org_Models_Eu_Only_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_models_eu_only_hint = /** @type {((inputs?: Org_Models_Eu_Only_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Models_Eu_Only_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Modelle anzeigen, die auf EU-Infrastruktur laufen.")
	return /** @type {LocalizedString} */ ("Show only models served from EU infrastructure.")
});